class MenuDetailViewController extends BaseTableViewController 
{

    static newInstance() : MenuDetailViewController {

        let vc = new MenuDetailViewController("menus-detail-view");
        vc.initWithResource("layout/menus/MenusDetailView.html");
        
        return vc;
    }

    private backButton: MUIButton = null;

    private optionsButton: MUIButton = null;
    private saveButton:MUIButton = null;

    private imageView: MUIImageView = null;
    private nameTextField: MUITextField = null;
    private languageButton:MUIButton = null;
    private priceTextField: MUITextField = null;    
    private taxDropDown:MUIButton = null;
    private absorbentSwitch:MUISwitchButton = null;
    private tagView:TagView = null;

    private headerView:MenuDetailHeader = null;

    private cf:MIONumberFormatter = MUIWebApplication.sharedInstance().delegate.currencyFormatter;

    viewDidLoad(){
        super.viewDidLoad();

        this.backButton = MUIOutlet( this, "back-btn", "MUIButton" );
        this.backButton.hidden = (this.navigationController == null);
        this.backButton.setAction(this, function(this:MenuDetailViewController) {
            this.navigationController.popViewController(true);
        });

        this.saveButton = MUIOutlet( this, "save-btn", "MUIButton" );
        this.saveButton.setAction( this, function() {
            DBHelper.saveMainContext();
        });

        this.optionsButton = MUIOutlet( this, "options-btn", "MUIButton" );
        this.optionsButton.setAction( this, this.showActions );

        this.nameTextField = MUIOutlet(this, "name-tf", "MUITextField");
        this.nameTextField.setOnChangeText(this, function(this:MenuDetailViewController, control:MUITextField, value:string) {
            let v = value.trim().length > 0 ? value.trim() : null;
            if ( v == null ) {
                AppHelper.showErrorMessage( this, MIOLocalizeString("INVALID_VALUE", "INVALID VALUE"), MIOLocalizeString("NAME_MUST_HAVE_A_VALUE", "NAME MUST HAVE A VALUE"));
                return;
            }
            this._menu.name = v;
        });

        this.languageButton = MUIOutlet(this, "language-btn", "MUIButton");
        this.languageButton.setAction(this, function(){
            let vc = ProductLanguageViewController.newInstance(); 
            vc.setItem(this._menu, "name");
            
            this.presentViewController( vc, true );
        });


        this.priceTextField = MUIOutlet(this, "price-tf", "MUITextField");

        this.imageView = MUIOutlet(this, 'menu-img','MUIImageView');

        this.taxDropDown = MUIOutlet(this, 'tax-btn', 'MUIButton');
        this.taxDropDown.setAction(this, function() {
            this.showTaxSelectEntityViewController(this.taxDropDown, "Tax"); //view popup for tax
        });
    
        this.absorbentSwitch = MUIOutlet(this, 'absorbent-switch', 'MUISwitchButton');
        this.absorbentSwitch.setOnChangeValue(this, function(this:MenuDetailViewController, control:MUISwitchButton, value:boolean){
            this._menu.isAbsorbent = value;
        });

       this.tagView = MUIOutlet(this, 'tag-view', 'TagView');
       this.tagView.delegate = this;

        this.headerView = MUIOutlet(this, "menu-header-view", "MenuDetailHeader");
        // this.headerView.hidden = true;

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;

        this.updateUI();
    }

    viewWillAppear(animate?){
        super.viewWillAppear(animate);
        this.updateUI();
    }

    private _menu_tags = null;
    private _menu:Menu;
    set item(item:Menu){        
        this._menu = item;
        this._menu_tags = (this._menu.tags == null || this._menu.tags?.length == 0) ? [] : this._menu.tags.split(',');
        this.updateUI();
    }   

    private updateUI(){
        if (this._menu == null) return;
        if (this.viewIsLoaded == false) return;    

        this.nameTextField.text = this._menu.name;
        this.taxDropDown.title = this._menu.tax.name;
        this.priceTextField.text = this._menu.price;
        this.absorbentSwitch.on = this._menu.isAbsorbent;

        let predicate = MIOPredicate.predicateWithFormat("type = " + TagType.ProductOrMenu + " && deletedAt = null");
        DBHelper.queryObjectsWithCompletion("Tag", null, predicate, [], this, function( this:MenuDetailViewController, objects:Tag[]){
            this.reloadTags(objects);
        });
    }

    private reloadTags(tags:Tag[]){
        this.tagView.removeAll();
        let sorted_tags = _MIOSortDescriptorSortObjects(tags, [MIOSortDescriptor.sortDescriptorWithKey("name", true)]);
        for (let index = 0; index < sorted_tags.length; index++){
            let tag = sorted_tags[index] as Tag;
            this.tagView.addTag(tag.name);
            if (this._menu_tags.containsObject(tag.name)) {
                this.tagView.selectTagAtIndex(index);
            }
        }
    }


    viewForHeaderInSection(tableView:UITableView, section:number) {
        let h = this.headerView.copy() as MenuDetailHeader;
        h.awakeFromHTML();
        h.hidden = false;
        
        let item = this.fetchedResultsController.objectAtIndexPath(MIOIndexPath.indexForRowInSection( 0, section )) as ProductMenu;
        h.item = item;
        return h;
    }

    // titleForHeaderInSection(tableView:UITableView, section:number) {
    //     let ip = MIOIndexPath.indexForRowInSection( 0, section );
    //     let item = this.fetchedResultsController.objectAtIndexPath( ip ) as ProductMenu;

    //     return item.menuCategory.name;
    // }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){  
        let cell = tableview.dequeueReusableCellWithIdentifier("MenuDetailCell") as MenuDetailCell;
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as ProductMenu;
        cell.item = item;            
        
        return cell;
    }
    
    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let selectedItem = this.fetchedResultsController.objectAtIndexPath(indexPath);
    }

    get fetchedResultsController() {
        if (this._fetchedResultsController != null) return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;

        let fetchRequest:MIOFetchRequest = null;
        let sortDescriptors = [
            MIOSortDescriptor.sortDescriptorWithKey("menuCategory.orderIndex", true),
            MIOSortDescriptor.sortDescriptorWithKey("menuCategory.name", true),
            MIOSortDescriptor.sortDescriptorWithKey("product.name", true)
        ];

        fetchRequest = DBHelper.listFetchRequestWithEntityName( "ProductMenu", sortDescriptors, "menuCategory.menu.identifier = " + this._menu.identifier );
        fetchRequest.relationshipKeyPathsForPrefetching = ["menuCategory", "product", "productFormat.format"];
        
        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, "categoryOrderIndex");
        fetchedResultsController.delegate = this;
        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;        
    }


    private showTaxSelectEntityViewController(dropdownButton, entityName) {
        let predicateFormat = null;        
        let vc = AppHelper.sharedInstance().showCustomSelectViewControllerFromView(dropdownButton, entityName, "name", predicateFormat, this, function(controller, object:MIOManagedObject){
            let title = object.valueForKey("name");
            //let value = object.valueForKey("identifier");
            this.taxDropDown.title = title;
            this._menu.tax = object;
        });        
    }

    private showActions(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle( MIOLocalizeString("ACTIONS", "ACTIONS"), MIOLocalizeString("CHOOSE_AN_ACTION", "CHOOSE AN ACTION"), MUIAlertViewStyle.Default );

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("DELETE_MENU", "DELETE MENU"), MUIAlertActionStyle.Destructive, this, function(this:MenuDetailViewController) {
            this.showDeleteConfirmation();
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString( "CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null) );

        this.presentViewController( avc, true );
    }

    private showDeleteConfirmation() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle( MIOLocalizeString("WARNING", "WARNING"), MIOLocalizeString("ARE_YOU_SURE?", "ARE YOU SURE?"), MUIAlertViewStyle.Default );

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("DELETE", "DELETE"), MUIAlertActionStyle.Destructive, this, function(this:MenuDetailViewController) {
            DBHelper.deleteObjectFromMainContext( this._menu, true );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString( "CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null) );

        this.presentViewController( avc, true );
    }

}
